var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRightHandMusicGroup = function SvgRightHandMusicGroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "17 39.7 177.007 130.6",
    viewBox: "0 0 211 202",
    height: 202,
    width: 211,
    "data-type": "shape",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.5 61.5c7.8 9.4 12.1 21.4 12.1 33.6 0 29.3-24 53.1-53.5 53.1s-53.5-23.8-53.5-53.1S75.6 42 105.1 42c14.3 0 27.7 5.5 37.8 15.6l1.6-1.7C134 45.5 120 39.7 105.1 39.7c-30.8 0-55.8 24.9-55.8 55.4 0 30.6 25 55.4 55.8 55.4 30.8 0 55.8-24.9 55.8-55.4 0-12.8-4.5-25.2-12.6-35.1l-1.8 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4 58.8c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7 97.4v12.2h10.1V97.4h10.8v-8.7H77.7v8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.3 109.6V88h-21.7V76.4H101v33.2h10.6V97.3h11v12.3h10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7 165.3c0-1-.8-1.9-2.4-1.9H17v6.7h1.9v-2.5h.7c.9 0 1 .3 1 .9v.2c0 .7 0 1.2.1 1.5h1.9c-.1-.3-.1-.8-.1-1.2v-.3c0-1.1-.4-1.6-.9-1.7.6-.3 1.1-.8 1.1-1.7zm-2.8.9H19v-1.4h.9c.6 0 .9.3.9.7 0 .4-.3.7-.9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7 163.4h-2v6.7h2v-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 164.7c.8 0 1 .4 1.1.8h2c-.1-1-1.1-2.2-3.1-2.2-2.2 0-3.4 1.5-3.4 3.6 0 1.9 1 3.4 3.1 3.4.9 0 1.6-.2 2-.8 0 .2.1.4.1.6h1.3v-3.9h-3.1v1.4h1.2c0 .4-.2 1.2-1.2 1.2-1.1 0-1.4-1-1.4-2.1 0-1 .3-2 1.4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 165.9h-2v-2.5h-2v6.7h2v-2.7h2v2.7h2v-6.7h-2v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3 164.9h2v5.2h1.9v-5.2h1.9v-1.5h-5.8v1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4 165.9h-2.1v-2.5h-2v6.7h2v-2.7h2.1v2.7h2v-6.7h-2v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.2 163.4-2.1 6.7H73l.4-1.3h2.1l.4 1.3H78l-2.2-6.7h-2.6zm.5 4c.3-1 .5-1.9.7-2.6.1.7.4 1.6.7 2.6h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 164.9c0 1.1 0 2.3.1 3-.3-.8-1.3-2.9-2-4.4h-2.4v6.7h1.8v-1.5c0-1.2 0-2.5-.1-3.1.3.9 1.5 3.4 2.1 4.6h2.2v-6.7H85v1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 163.4h-2.9v6.7H93c2.2 0 3.4-1.5 3.4-3.4s-1.3-3.3-3.4-3.3zm-.2 5.3H92v-3.9h.8c1.1 0 1.5.8 1.5 1.9 0 1.3-.4 2-1.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 167.8c-.2-1-.6-3-.9-4.3h-2.8v6.7h1.8V168c0-1.2 0-2.5-.1-3.3h.1c.3 1.5.7 3.5 1.1 5.4h1.6c.5-2 .9-4 1.2-5.4h.1c0 .8-.1 2.2-.1 3.2v2.2h1.9v-6.7h-2.8c-.4 1.5-.9 3.3-1.1 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5 167.6c0 .9-.4 1.3-1 1.3s-1.1-.3-1.1-1.3v-4.1h-2v3.9c0 2.2 1.2 2.9 3 2.9 1.7 0 3-.7 3-2.9v-3.9h-2v4.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8 165.9c-1-.3-1.3-.4-1.3-.8s.3-.5.7-.5c.7 0 .9.4.9.7h1.9c-.1-1.1-.9-2.1-2.8-2.1s-2.7.9-2.7 2.1c0 .9.4 1.6 2.4 2.1 1.1.3 1.4.4 1.4.9 0 .4-.3.6-.9.6-.6 0-1-.3-1.2-.8h-1.9c.1 1.3 1.1 2.2 3 2.2 2 0 2.9-.9 2.9-2.1.1-1-.3-1.8-2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1 163.4h-2v6.7h2v-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.5 168.9c-1 0-1.3-1.1-1.3-2.1 0-1.2.3-2.1 1.3-2.1.7 0 1 .4 1.1.9h2c-.1-1.2-1-2.3-3-2.3-2.3 0-3.4 1.6-3.4 3.5 0 2 1.1 3.4 3.3 3.4 1.8 0 2.9-.9 3.1-2.3h-2c-.1.4-.3 1-1.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6 164.7c.8 0 1 .4 1.1.8h2c-.1-1-1.1-2.2-3.1-2.2-2.2 0-3.4 1.5-3.4 3.6 0 1.9 1 3.4 3.1 3.4.9 0 1.6-.2 2-.8 0 .2.1.4.1.6h1.3v-3.9h-3.1v1.4h1.2c0 .4-.2 1.2-1.2 1.2-1.1 0-1.4-1-1.4-2.1 0-1 .3-2 1.4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6 165.3c0-1-.8-1.9-2.4-1.9h-3.3v6.7h1.9v-2.5h.7c.9 0 1 .3 1 .9v.2c0 .7 0 1.2.1 1.5h1.9c-.1-.3-.1-.8-.1-1.2v-.3c0-1.1-.4-1.6-.9-1.7.5-.3 1.1-.8 1.1-1.7zm-2.9.9h-.9v-1.4h.9c.6 0 .9.3.9.7 0 .4-.2.7-.9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8 163.3c-2.3 0-3.5 1.6-3.5 3.5s1.1 3.5 3.4 3.5 3.4-1.6 3.4-3.5c0-2-1.2-3.5-3.3-3.5zm0 5.5c-1 0-1.4-.9-1.4-2.1 0-1.2.4-2 1.4-2 1 0 1.4.8 1.4 2.1-.1 1.1-.4 2-1.4 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2 167.6c0 .9-.4 1.3-1 1.3s-1.1-.3-1.1-1.3v-4.1h-2v3.9c0 2.2 1.2 2.9 3 2.9 1.7 0 3-.7 3-2.9v-3.9h-2v4.1h.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5 163.4h-3.1v6.7h1.9v-2.4h1.1c1.4 0 2.6-.7 2.6-2.2.1-1.2-.9-2.1-2.5-2.1zm-.3 3h-.8v-1.6h.8c.5 0 .9.2.9.8 0 .6-.4.8-.9.8z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightHandMusicGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-hand-music-group.61160d50.svg";
export { ForwardRef as ReactComponent };